export const MEMBERSHIP_PAYMENT_MODE = {
  cc: "Credit Card",
  cash: "Cash",
};
